<template>
	<div class="searchBox">
		<div class="search">
			<div class="seleft" :class="{bor:type==2||type==3}">
				<div v-if="type!=3&&type!=4" class="type" @click.stop="openStatus()">
					<div class="">
						职位类型
					</div>
					<img src="@/static/pull.png" class="icon" />
				</div>
				<input type="text" v-model="value" :placeholder="place" class="input" />
			</div>
			<div class="button" @click="serach()">
				搜索
			</div>
		</div>
	</div>
</template>

<script>
	import classType from '@/components/classType.vue'
	export default {
		name: 'searchBox',
		components: {
			classType
		},
		props: ['type', 'place'], // 1.首页 2.职位搜索 3.公司搜索 4.政策中心 5.政策搜搜
		data() {
			return {
				value: ''
			}
		},
		created() {

		},
		methods: {
			serach() {
				this.$emit('search', this.value)
			},
			childMethod(value){
				this.value = value
			},
			// 打开或关闭弹窗
			openStatus(){
				this.$emit('openStatus')
			}
		}
	}
</script>

<style lang="scss" scoped>
	.searchBox {
		input {
			&::placeholder {
				/* Chrome, Firefox, Opera, Safari 10.1+ */
				color: #A3A7B3;
			}

			border: none;
			outline: none;
		}

		.search {
			background-color: #51A190;
			width: 1030px;
			height: 62px;
			border-radius: 12px;
			margin: 0 auto 48px;
			display: flex;
			align-items: center;
			position: relative;
			z-index: 3;

			.bor {
				border: 2px solid #51A190;
			}

			.seleft {
				width: 896px;
				display: flex;
				align-items: center;
				background-color: #fff;
				border-radius: 12px;
				height: 100%;
				padding: 0 24px;
				box-sizing: border-box;
				font-size: 18px;

				.type {
					display: flex;
					align-items: center;
					color: #151515;
					margin-right: 36px;
					cursor: pointer;
					font-weight: bold;

					.icon {
						margin-left: 18px;
						width: 12px;
						height: 12px;
					}
				}

				.input {
					font-size: 18px;
					flex: 1;
				}
			}

			.button {
				flex: 1;
				text-align: center;
				font-size: 22px;
				color: #fff;
				cursor: pointer;
			}

			
		}
	}
</style>